module.exports = __webpack_public_path__ + "img/leifkare.03376a33.png";